export default __webpack_public_path__ + "static/media/John Dark Mode.dbca7265.svg";